import { AxiosRequestConfig } from "axios";
import { RunContextApp } from "framework/RCApp";
import { ApiResponse } from "types";
import { GetUserLoadAPI } from "types/userManagement/userManagementInterface";

export const UserManagementAPI = {
  fetchUserLoad: async (
    rc: RunContextApp,
    params: any
  ): Promise<ApiResponse<GetUserLoadAPI.retval>> => {

    const request: AxiosRequestConfig = {
      params: params
    }

    const resp = await rc.apiClient.get<GetUserLoadAPI.retval>(
      GetUserLoadAPI.apiEndpoint(params.pilotId),
      request
    );
    return resp;
  },

};
